var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCubeInMotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4819 8.62377L19.4819 3.12377C19.3343 3.04258 19.1685 3 19 3C18.8315 3 18.6657 3.04258 18.5181 3.12377L8.5181 8.62377C8.36131 8.7101 8.23057 8.83692 8.13951 8.99101C8.04845 9.14509 8.00041 9.32079 8.00041 9.49977C8.00041 9.67875 8.04845 9.85446 8.13951 10.0085C8.23057 10.1626 8.36131 10.2894 8.5181 10.3758L18 15.5911V26.3084L14.9638 24.6391L14 26.391L18.5181 28.8758C18.6657 28.9571 18.8315 28.9998 19 28.9998C19.1685 28.9998 19.3343 28.9571 19.4819 28.8758L29.4819 23.3758C29.6388 23.2895 29.7696 23.1627 29.8607 23.0086C29.9519 22.8545 30 22.6788 30 22.4998V9.49977C30 9.32075 29.9519 9.14502 29.8607 8.99093C29.7696 8.83684 29.6388 8.71004 29.4819 8.62377ZM19 5.14137L26.9248 9.49977L19 13.8582L11.0752 9.49977L19 5.14137ZM28 21.9085L20 26.3085V15.5911L28 11.1911V21.9085Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.9998H10V13.9998H2V15.9998Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23.9998H12V21.9998H4V23.9998Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.9998H14V17.9998H6V19.9998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCubeInMotion);
export default __webpack_public_path__ + "static/media/ic-cube-in-motion.c050f311107ebe444ca38a85bfc72573.svg";
export { ForwardRef as ReactComponent };